module.exports = {"top3":["Home health patients without improved mobility","Uninsured children","Adults without all recommended vaccines"],"bottom3":["Adults who report fair or poor health","Adults who have lost six or more teeth","Drug poisoning deaths"],"most_improved":["Colorectal cancer deaths","Home health patients without improved mobility","Uninsured adults"],"most_declined":["Hospital 30-day mortality","Preventable hospitalizations ages 18-64","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/WV.json
// module id = 289
// module chunks = 143196823979170 184088790168614